(() => {
  'use strict';
  if (window.FAFPageHistory) return;

  const namespace = 'fafPageHistory';
  const storageKey = 'faf-page-history-v1';
  const lifetime = 24 * 60 * 60 * 1000;
  const excluded = 'dialog,[role="dialog"],cart-drawer,menu-drawer,quick-add-modal,quick-view-modal,header,nav,form,[data-faf-menu-panel],[data-faf-menu-root]';
  const originalPush = history.pushState;
  const originalReplace = history.replaceState;
  const nativePush = originalPush.bind(history);
  const nativeReplace = originalReplace.bind(history);
  const main = () => document.getElementById('MainContent');
  const delegated = () => Boolean(document.querySelector('.collection-grid-layout #ProductGridContainer #product-grid.load-more-grid') ||
    document.querySelector('[data-faf-search-page][data-section-id]') && (new URLSearchParams(location.search).get('q') || '').trim());
  const uniqueKey = () => Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  const plainState = state => {
    try { return state === null || state === undefined || typeof state === 'object' &&
      !Array.isArray(state) && (Object.getPrototypeOf(state) === Object.prototype || Object.getPrototypeOf(state) === null); }
    catch { return false; }
  };
  const signature = () => {
    const value = [window.Shopify?.theme?.id || '', window.Shopify?.country || '', window.Shopify?.currency?.active || '',
      document.documentElement.lang, location.pathname + location.search + location.hash].join('|');
    let first = 0x811c9dc5, second = 0x9e3779b9;
    for (let index = 0; index < value.length; index += 1) {
      const code = value.charCodeAt(index);
      first = Math.imul(first ^ code, 0x01000193);
      second = Math.imul(second ^ code, 0x85ebca6b);
    }
    return (first >>> 0).toString(16).padStart(8, '0') + (second >>> 0).toString(16).padStart(8, '0');
  };
  let key = null, suspended = false, guard = null, frame = null, scrollTimer = null;
  let phase = 'idle', reason = 'initial', ignoreHashChangeURL = null, memoryView = null;

  function active() { return Boolean(main()) && !delegated(); }
  function pageY() {
    const top = parseFloat(document.body?.style.top);
    return document.body?.style.position === 'fixed' && Number.isFinite(top) && top <= 0 ? -top : Math.max(0, window.scrollY);
  }
  function safeTop() {
    const header = document.querySelector('.shopify-section-header') || document.querySelector('body > header');
    const rect = header?.getBoundingClientRect();
    return rect && rect.bottom > 0 && rect.top < window.innerHeight ? Math.min(rect.bottom + 8, window.innerHeight / 2) : 0;
  }
  function eligible(node) { return Boolean(node && main()?.contains(node) && !node.closest(excluded)); }
  function locator(node) {
    if (!eligible(node)) return null;
    if (node.id) return { id: node.id };
    const path = [];
    let ancestor = node;
    while (ancestor && ancestor !== main() && !ancestor.id && path.length < 8) {
      path.unshift(Array.prototype.indexOf.call(ancestor.parentElement.children, ancestor));
      ancestor = ancestor.parentElement;
    }
    return ancestor?.id && path.length ? { id: ancestor.id, path, tag: node.tagName } : null;
  }
  function locate(ref) {
    if (!ref || typeof ref.id !== 'string' || ref.id.length > 300) return null;
    let node = document.getElementById(ref.id);
    if (ref.path !== undefined) {
      if (!Array.isArray(ref.path) || ref.path.length > 8) return null;
      for (const index of ref.path) {
        if (!Number.isInteger(index) || index < 0) return null;
        node = node?.children[index];
      }
    }
    return eligible(node) && (!ref.tag || ref.tag === node.tagName) ? node : null;
  }
  function entries() {
    try {
      const stored = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      return Array.isArray(stored) ? stored.filter(view => view && Number.isFinite(view.savedAt) && Date.now() - view.savedAt < lifetime).slice(-20) : [];
    } catch { return []; }
  }
  function valid(view) {
    return view && view.key === key && view.signature === signature() && Number.isFinite(view.savedAt) &&
      Date.now() - view.savedAt < lifetime && Number.isFinite(view.y) && view.y >= 0;
  }
  function saved() {
    const entry = history.state?.[namespace];
    if (!entry || entry.key !== key) return valid(memoryView) ? memoryView : null;
    const candidates = [entries().find(item => item.key === key), entry.view, memoryView].filter(valid);
    return candidates.sort((a, b) => b.savedAt - a.savedAt)[0] || null;
  }
  function adoptEntry() {
    const entry = history.state?.[namespace];
    key = typeof entry?.key === 'string' && entry.key.length < 160 ? entry.key : uniqueKey();
    if (!entry && plainState(history.state)) {
      try { nativeReplace({ ...history.state, [namespace]: { key } }, '', location.href); } catch {}
    }
  }
  function findAnchor() {
    const top = safeTop();
    let best = null, distance = Infinity;
    for (const node of main().querySelectorAll('[id],h1,h2,h3,h4,p,summary,li,figure')) {
      if (!eligible(node) || node.matches('script,style,input,select,textarea,button,option') || node.closest('[hidden]')) continue;
      const rect = node.getBoundingClientRect();
      if (rect.height <= 0 || rect.width <= 0 || rect.bottom <= top || rect.top >= window.innerHeight) continue;
      const score = Math.abs(rect.top - top);
      if (score < distance && locator(node)) { best = node; distance = score; }
    }
    if (!best) return null;
    const rect = best.getBoundingClientRect();
    return { ref: locator(best), offset: rect.top, height: rect.height };
  }
  function railProduct(card) {
    const href = card?.querySelector('a[href*="/products/"]')?.getAttribute('href');
    try { return href ? new URL(href, location.origin).pathname : ''; } catch { return ''; }
  }
  function capture() {
    if (!active() || suspended || guard) return false;
    const details = Array.from(main().querySelectorAll('details')).filter(eligible).slice(0, 40)
      .map(node => ({ ref: locator(node), open: node.open })).filter(item => item.ref);
    const rails = Array.from(main().querySelectorAll('[data-product-rail],.product-recommendations .slider')).filter(eligible).slice(0, 12)
      .map(node => {
        const rect = node.getBoundingClientRect();
        const card = Array.from(node.children).find(child => child.getBoundingClientRect().right > rect.left + 2 && child.getBoundingClientRect().left < rect.right);
        return { ref: locator(node), left: node.scrollLeft, width: node.clientWidth,
          anchor: card ? { product: railProduct(card), offset: card.getBoundingClientRect().left - rect.left } : null };
      }).filter(item => item.ref);
    const view = { key, signature: signature(), savedAt: Date.now(), y: pageY(), viewportWidth: window.innerWidth, anchor: findAnchor(), details, rails };
    memoryView = view;
    if (plainState(history.state)) {
      try { nativeReplace({ ...history.state, [namespace]: { key, view } }, '', location.href); } catch {}
    }
    try { sessionStorage.setItem(storageKey, JSON.stringify([...entries().filter(item => item.key !== key), view].slice(-20))); } catch {}
    document.dispatchEvent(new CustomEvent('faf:page-history-captured', { detail: { key } }));
    return true;
  }
  function stop(nextReason = 'cancelled', save = false) {
    guard?.();
    guard = null;
    phase = 'idle';
    reason = nextReason;
    if (frame !== null) cancelAnimationFrame(frame);
    frame = null;
    clearTimeout(scrollTimer);
    if (save) capture();
  }
  function releaseMenuLock() {
    for (const menu of document.querySelectorAll('faf-mobile-navigation')) {
      if (!menu.scrollLock) continue;
      if (typeof menu.closeMenu === 'function') menu.closeMenu('history');
      else if (typeof menu.unlockScroll === 'function') menu.unlockScroll();
    }
  }
  function restoreUI(view) {
    if (Array.isArray(view.details)) view.details.slice(0, 40).forEach(item => {
      if (!item || typeof item !== 'object') return;
      const node = locate(item.ref);
      if (node?.tagName === 'DETAILS' && typeof item.open === 'boolean' && node.open !== item.open) node.open = item.open;
    });
    if (Array.isArray(view.rails)) view.rails.slice(0, 12).forEach(item => {
      if (!item || typeof item !== 'object') return;
      const node = locate(item.ref);
      if (!node?.matches('[data-product-rail],.product-recommendations .slider') || !Number.isFinite(item.left)) return;
      const card = item.anchor?.product ? Array.from(node.children).find(child => railProduct(child) === item.anchor.product) : null;
      if (card && Math.abs(node.clientWidth - item.width) > 2) {
        const rect = node.getBoundingClientRect();
        node.scrollLeft += card.getBoundingClientRect().left - rect.left;
      } else node.scrollLeft = item.left;
    });
  }
  function restore(view, source) {
    if (!active() || !valid(view)) return;
    stop('restarting');
    suspended = false;
    releaseMenuLock();
    restoreUI(view);
    const expectedKey = key, expectedSignature = signature();
    const current = () => !suspended && active() && key === expectedKey && signature() === expectedSignature;
    let previousMode = 'auto', stopped = false, observer = null, timer = null;
    try { previousMode = history.scrollRestoration || 'auto'; history.scrollRestoration = 'manual'; } catch {}
    phase = 'restoring';
    reason = source;
    const correct = () => {
      frame = null;
      if (!current() || stopped) return;
      restoreUI(view);
      const node = locate(view.anchor?.ref);
      let top = view.y;
      if (view.y <= 2) top = 0;
      else if (node && Number.isFinite(view.anchor?.offset)) {
        const rect = node.getBoundingClientRect();
        const changed = Math.abs(view.viewportWidth - window.innerWidth) > 2;
        let offset = view.anchor.offset;
        if (changed || offset + rect.height <= safeTop() || offset >= window.innerHeight - 24) offset = safeTop();
        top = pageY() + rect.top - offset;
      }
      const limit = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      top = Math.max(0, Math.min(top, limit));
      if (Math.abs(pageY() - top) > 2) window.scrollTo({ top, behavior: 'instant' });
    };
    const schedule = () => { if (!stopped && current() && frame === null) frame = requestAnimationFrame(correct); };
    const cleanup = () => {
      if (stopped) return;
      stopped = true;
      clearTimeout(timer);
      observer?.disconnect();
      ['resize', 'scroll', 'load', 'pageshow'].forEach(type => window.removeEventListener(type, schedule));
      document.removeEventListener('load', schedule, true);
      document.fonts?.removeEventListener?.('loadingdone', schedule);
      try { if (history.scrollRestoration === 'manual') history.scrollRestoration = previousMode; } catch {}
    };
    guard = cleanup;
    ['resize', 'scroll', 'load', 'pageshow'].forEach(type => window.addEventListener(type, schedule, { passive: true }));
    document.addEventListener('load', schedule, true);
    document.fonts?.addEventListener?.('loadingdone', schedule);
    document.fonts?.ready?.then(schedule).catch(() => {});
    if (typeof ResizeObserver === 'function') {
      observer = new ResizeObserver(schedule);
      observer.observe(main());
      observer.observe(document.documentElement);
    }
    timer = setTimeout(() => stop('settled', true), 10000);
    frame = requestAnimationFrame(() => {
      correct();
      if (!current() || stopped) return;
      frame = requestAnimationFrame(() => {
        correct();
        if (!current() || stopped) return;
        phase = 'guarding';
        document.dispatchEvent(new CustomEvent('faf:page-position-restored', { detail: { key, source } }));
      });
    });
  }
  function installHistoryHooks() {
    history.pushState = function(state, title, url) {
      if (this !== history) return Reflect.apply(originalPush, this, arguments);
      if (!active()) return nativePush(...arguments);
      if (!plainState(state)) {
        stop('push-native', true);
        const result = nativePush(...arguments);
        key = uniqueKey();
        memoryView = null;
        return result;
      }
      stop('push', true);
      const nextKey = uniqueKey();
      const args = Array.from(arguments);
      args[0] = { ...state, [namespace]: { key: nextKey } };
      const result = nativePush(...args);
      key = nextKey;
      memoryView = null;
      requestAnimationFrame(() => capture());
      return result;
    };
    history.replaceState = function(state, title, url) {
      if (this !== history) return Reflect.apply(originalReplace, this, arguments);
      if (!active()) return nativeReplace(...arguments);
      if (!plainState(state)) {
        const result = nativeReplace(...arguments);
        stop('replace-native');
        return result;
      }
      const args = Array.from(arguments);
      const prior = history.state?.[namespace];
      args[0] = { ...state, [namespace]: { key, ...(prior?.key === key && prior.view ? { view: prior.view } : {}) } };
      const result = nativeReplace(...args);
      if (guard && !valid(memoryView || prior?.view)) stop('replace');
      requestAnimationFrame(() => capture());
      return result;
    };
  }
  function boot() {
    if (!active()) {
      reason = delegated() ? 'delegated' : 'no-main';
      document.dispatchEvent(new CustomEvent('faf:page-history-ready'));
      return;
    }
    adoptEntry();
    installHistoryHooks();
    const view = saved();
    const navigation = performance.getEntriesByType?.('navigation')?.[0]?.type;
    if (view && (navigation === 'back_forward' || navigation === 'reload')) restore(view, navigation);
    else requestAnimationFrame(() => capture());
    document.dispatchEvent(new CustomEvent('faf:page-history-ready'));
  }
  window.FAFPageHistory = Object.freeze({ capture, cancel: () => stop('cancelled', true),
    diagnostics: () => Object.freeze({ active: active(), restoring: phase === 'restoring', guarding: Boolean(guard), key, reason, phase }) });
  ['pointerdown', 'touchstart', 'wheel'].forEach(type => document.addEventListener(type, () => { if (guard) stop('shopper', true); }, { passive: true, capture: true }));
  document.addEventListener('keydown', event => { if (guard && !['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) stop('shopper', true); }, true);
  ['click', 'auxclick', 'contextmenu'].forEach(type => document.addEventListener(type, event => {
    if (event.target instanceof Element && event.target.closest('a[href]')) { if (guard) stop('link'); capture(); }
  }, true));
  document.addEventListener('submit', () => { if (guard) stop('submit'); capture(); }, true);
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(capture, 250);
  }, { passive: true, capture: true });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') capture(); });
  window.addEventListener('pagehide', () => {
    if (!active()) return;
    stop('pagehide', true);
    suspended = true;
  });
  window.addEventListener('pageshow', event => {
    if (!active()) return;
    suspended = false;
    if (event.persisted) { adoptEntry(); const view = saved(); if (view) restore(view, 'bfcache'); else releaseMenuLock(); }
    else if (!guard) capture();
  });
  window.addEventListener('popstate', () => {
    if (!active()) return;
    stop('popstate');
    adoptEntry();
    ignoreHashChangeURL = location.href;
    setTimeout(() => { ignoreHashChangeURL = null; }, 0);
    const view = saved();
    if (view) restore(view, 'popstate');
  });
  window.addEventListener('hashchange', event => {
    if (!active() || event.newURL === ignoreHashChangeURL) return;
    stop('hash');
    key = uniqueKey();
    memoryView = null;
    if (plainState(history.state)) {
      try { nativeReplace({ ...history.state, [namespace]: { key } }, '', location.href); } catch {}
    }
    requestAnimationFrame(() => capture());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
